import React, { useRef } from 'react';

let heroTitleGradSeq = 0;

export function HeroTitleSvg({ className, shimmer }) {
  const gradIdRef = useRef(null);
  if (gradIdRef.current === null) {
    heroTitleGradSeq += 1;
    gradIdRef.current = `heroTitleGrad-${heroTitleGradSeq}`;
  }
  const gradId = gradIdRef.current;

  return (
    <svg
      className={className}
      viewBox="0 0 1381 157"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M0 157H62.2835V41.7835H156.806V157H218.871V0.00266312H0V157ZM374.583 107.834C434.238 107.834 452 83.7772 452 55.2856V51.9121C452 23.0002 434.677 0 374.583 0H238.611V156.997H300.895V107.831H374.583V107.834ZM300.895 39.248H367.125C381.603 39.248 387.74 44.7367 387.74 53.5988V54.2321C387.74 62.8841 381.384 68.5829 367.125 68.5829H300.895V39.248ZM629.424 157H691.707V0.00266312H629.424L527.004 98.7585V0.00266312H464.721V157H527.004L629.424 58.4516V157ZM847.637 157H909.701V0.00266312H847.637V61.8305C837.114 63.943 823.511 64.9965 811.231 64.9965C782.941 64.9965 767.153 60.7769 767.153 36.9307V0.00266312H704.87V44.5265C704.87 92.0061 736.227 106.775 796.101 106.775C819.569 106.775 836.015 104.668 847.637 102.555V157ZM1097 157H1165.2L1079.89 0.00266312H996.113L915.41 157H978.568L991.07 131.68H1084.28L1097 157H1097ZM1010.15 92.4292L1036.9 38.4073L1064.32 92.4292H1010.15ZM1318.72 157H1381V0.00266312H1194.59C1194.59 81.4545 1192.4 99.1789 1186.25 106.565C1182.53 111.207 1177.48 112.263 1168.71 112.263H1165.42V157H1185.6C1215.64 157 1229.02 150.245 1238.01 136.11C1246.78 122.392 1250.95 102.975 1251.17 40.3069H1318.72V157Z"
        fill={`url(#${gradId})`}
      />
      <defs>
        {shimmer ? (
          <linearGradient
            id={gradId}
            x1="-0.65"
            y1="0"
            x2="1.65"
            y2="0"
            gradientUnits="objectBoundingBox"
          >
            <stop offset="0%" stopColor="#fff" stopOpacity="1" />
            <stop offset="10%" stopColor="#fff" stopOpacity="1" />
            <stop offset="24%" stopColor="#fff" stopOpacity="0.92" />
            <stop offset="36%" stopColor="#fff" stopOpacity="0.72" />
            <stop offset="44%" stopColor="#fff" stopOpacity="0.52" />
            <stop offset="50%" stopColor="#fff" stopOpacity="0.4" />
            <stop offset="56%" stopColor="#fff" stopOpacity="0.52" />
            <stop offset="64%" stopColor="#fff" stopOpacity="0.72" />
            <stop offset="76%" stopColor="#fff" stopOpacity="0.92" />
            <stop offset="90%" stopColor="#fff" stopOpacity="1" />
            <stop offset="100%" stopColor="#fff" stopOpacity="1" />
            <animateTransform
              attributeName="gradientTransform"
              type="translate"
              from="-1.25 0"
              to="1.45 0"
              dur="2.2s"
              repeatCount="indefinite"
            />
          </linearGradient>
        ) : (
          <linearGradient
            id={gradId}
            x1="0"
            y1="78.5"
            x2="1381"
            y2="78.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0.2" />
          </linearGradient>
        )}
      </defs>
    </svg>
  );
}
